import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'tech-core-quiz-instructions',
  standalone: false,
  templateUrl: './instructions.component.html',
  styleUrl: './instructions.component.scss'
})
export class InstructionsComponent implements  OnInit{

  userName: string = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
              ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.userName = params['username'];
      console.log("Received Username:", this.userName);
    });
  }

  navigateToQuestions() {
    this.router.navigate(["/questions"], {queryParams: {username: this.userName}});
  }

}
